import { TextField } from "@material-ui/core";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../App";
import { userAdminFields } from "../../../rbac-consts";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY, userAdminFieldsConsts } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import { getUserAdminField, updateUseAdminFields } from "../../../utils/userAdminFieldsUtils";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Can from "../../can/Can";
import { StyledClientsEditNickname } from "../../clients/styledClients";
import DescriptionItemShow from "./DescriptionItemShow";

const DescriptionFormItem = ({ client, t, notification, setNotification }) => {
  const { user } = useContext(AppContext);

  const [currentDescription, setCurrentDescription] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const save = () => {
    if (!currentDescription || currentDescription === getUserAdminField(userAdminFieldsConsts.DESCRIPTION, client.userAdminFields)?.value) {
      setIsEdit(false);
      return;
    }

    if (!!getUserAdminField(userAdminFieldsConsts.DESCRIPTION, client.userAdminFields)?.value) {
      handleUpdate();

      return;
    }

    handleCreate();
  };

  const handleCreate = () => {
    let data = {
      client: "/api/users/" + client.id,
      name: "description",
      value: currentDescription
    };

    axios.post("/api/user-admin-fields", data, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setIsEdit(false);

        client.userAdminFields = updateUseAdminFields(response.data, client.userAdminFields);

        setNotification({ ...notification, visible: true, type: "success", message: t("nicknameForm.successEdit") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const handleUpdate = () => {
    let data = {
      value: currentDescription
    };

    axios.put(`/api/user-admin-fields/${getUserAdminField(userAdminFieldsConsts.DESCRIPTION, client.userAdminFields)?.id}`, data, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setIsEdit(false);

        setNotification({ ...notification, visible: true, type: "success", message: t("nicknameForm.successEdit") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    setCurrentDescription(getUserAdminField(userAdminFieldsConsts.DESCRIPTION, client.userAdminFields)?.value);
  }, []);

  return (
    <Can
      role={user.roles}
      perform={userAdminFields.CHANGE}
      yes={() => (
        <StyledClientsEditNickname>
          {isEdit ? (
            <div className="nickname-edit-form">
              <TextField
                id={`nickname.${client.id}`}
                defaultValue={currentDescription ?? ""}
                onChange={(event) => setCurrentDescription(event.target.value)}
              />
              <div className="nickname-edit-form__actions">
                <button
                  className="table-action"
                  onClick={save}
                >
                  <span className="icon-light-check" />
                  {t("table.nickName.save")}
                </button>
                <button
                  className="table-action table-action_danger"
                  onClick={() => {
                    setIsEdit(false);
                  }}
                >
                  <span className="icon-light-cancel" />
                  {t("table.nickName.cancel")}
                </button>
              </div>
            </div>
          ) : (
            <div className="nickname-edit">
              <DescriptionItemShow
                description={currentDescription}
                t={t}
              />
              <button
                className="table-action table-action_info"
                onClick={() => setIsEdit(true)}
              >
                <span className="icon-light-edit" />
                {t("table.nickName.edit")}
              </button>

            </div>
          )}
        </StyledClientsEditNickname>
      )}
    />
  );
};

export default DescriptionFormItem;